import React from 'react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2>About Tritunas Putra Nusantara</h2>
          <p>Expert Fiber Optic Contractor for Infrastructure Projects</p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <h3>Who We Are</h3>
            <p>
              PT Tritunas Putra Nusantara adalah perusahaan yang bergerak di bidang jasa konstruksi dan telekomunikasi, dengan visi menjadi kontraktor nasional yang andal, lincah, dan inovatif. Berawal dari tim kecil yang berkomitmen tinggi, kami telah menyelesaikan berbagai proyek strategis dan terus berkembang sebagai mitra terpercaya bagi klien dari sektor swasta maupun pemerintahan.
            </p>
            <p>
              Kami percaya bahwa setiap proyek bukan hanya tentang pembangunan fisik, melainkan juga tentang membangun koneksi, kepercayaan, dan keberlanjutan pertumbuhan bersama. Dengan dukungan tenaga ahli berpengalaman, standar kerja profesional, serta komitmen pada kualitas dan keselamatan, PT Tritunas Putra Nusantara siap memberikan solusi terbaik yang bernilai bagi setiap mitra.
            </p>

            <div className="about-stats">
              <div className="stat">
                <div className="stat-number">100+</div>
                <div className="stat-label">Projects Completed</div>
              </div>
              <div className="stat">
                <div className="stat-number">500km+</div>
                <div className="stat-label">Fiber Installed</div>
              </div>
              <div className="stat">
                <div className="stat-number">20+</div>
                <div className="stat-label">Years Experience</div>
              </div>
            </div>
          </div>

          <div className="about-values">
            <h3>Why Choose Us?</h3>
            <div className="values-grid">
              <div className="value-item">
                <div className="value-icon">
                  <i className="fas fa-hard-hat"></i>
                </div>
                <h4>Professional Engineering</h4>
                <p>Experienced in complex fiber optic construction and project management.</p>
              </div>

              <div className="value-item">
                <div className="value-icon">
                  <i className="fas fa-tools"></i>
                </div>
                <h4>End-to-End Service</h4>
                <p>From planning and installation to testing and maintenance, we cover all aspects.</p>
              </div>

              <div className="value-item">
                <div className="value-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <h4>Quality & Safety</h4>
                <p>Strict adherence to industry standards and safety protocols on every project.</p>
              </div>

              <div className="value-item">
                <div className="value-icon">
                  <i className="fas fa-network-wired"></i>
                </div>
                <h4>Reliable Results</h4>
                <p>Proven track record of delivering robust, high-performance fiber networks.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;